/** The server ends a lagging subscription stream with `RESYNC_REQUIRED` while
 *  the socket stays open, so the WS-reconnect refetch never fires: the caller
 *  must refetch and resubscribe itself. */
export const isResyncRequired = (err: unknown): boolean => {
  const errors = (
    err as { graphQLErrors?: { extensions?: { code?: string } }[] }
  )?.graphQLErrors;
  if (errors?.some((e) => e.extensions?.code === 'RESYNC_REQUIRED'))
    return true;
  return (
    Array.isArray(err) &&
    err.some((e) => e?.extensions?.code === 'RESYNC_REQUIRED')
  );
};
